import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
    fill?: string;
    variant?: 'dark' | 'light';
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const LogoDebitCard = ({ className, fill, variant = 'light' }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        width={28}
        height={20}
        viewBox='0 0 28 20'
        fill='none'
    >
        <rect
            width='28'
            height='20'
            fill={variant === 'light' ? fill : '#ffffff'}
        />
        <path
            d='M8.4 15C8.015 15 7.68542 14.8776 7.41125 14.6328C7.13708 14.388 7 14.0938 7 13.75V6.25C7 5.90625 7.13708 5.61198 7.41125 5.36719C7.68542 5.1224 8.015 5 8.4 5H19.6C19.985 5 20.3146 5.1224 20.5887 5.36719C20.8629 5.61198 21 5.90625 21 6.25V13.75C21 14.0938 20.8629 14.388 20.5887 14.6328C20.3146 14.8776 19.985 15 19.6 15H8.4ZM8.4 10H19.6V7.5H8.4V10Z'
            fill={variant === 'light' ? '#ffffff' : fill}
        />
    </SvgElement>
);
